import { COUPONS_API } from 'modules/coupons/api/coupon-api'
import { CouponFunnelsApiInterface } from 'modules/coupons/types/coupon-edit-interface'
import useUser from 'shared/hooks/use-user'
import { SwrPaginationInterface } from 'shared/types/pagination-interface'
import { baseFetcher } from 'shared/utils/http-client'
import useSWR from 'swr'

interface UseCouponFunnelsInterface extends SwrPaginationInterface {
  id: string
}

export function useCouponFunnels({ pagination, limit, id }: UseCouponFunnelsInterface) {
  const { user } = useUser()

  return useSWR<CouponFunnelsApiInterface>(() => {
    if (user && pagination.startFromId === undefined && limit) {
      return `${COUPONS_API}/funnels-list/${id}?pagination[limit]=${limit}`
    } else if (user && pagination.startFromId && limit) {
      return `${COUPONS_API}/funnels-list/${id}?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}`
    }
    return null
  }, baseFetcher)
}
